// eslint-disable-next-line
export function isNumeric(n: any) {
  return !isNaN(parseFloat(n)) && isFinite(n)
}
